/**
 * @generated SignedSource<<9691a66aedf608e6d51d4bd87d693c40>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type AwardsListItem_awardsListItem$data = {
  readonly awardName: string;
  readonly awardText: string;
  readonly logoUrl: string | null | undefined;
  readonly year: string;
  readonly " $fragmentType": "AwardsListItem_awardsListItem";
};
export type AwardsListItem_awardsListItem$key = {
  readonly " $data"?: AwardsListItem_awardsListItem$data;
  readonly " $fragmentSpreads": FragmentRefs<"AwardsListItem_awardsListItem">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "AwardsListItem_awardsListItem",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "year",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "logoUrl",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "awardName",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "awardText",
      "storageKey": null
    }
  ],
  "type": "AwardsListItem",
  "abstractKey": null
};

(node as any).hash = "f81aaa5897e228785b069afd02ace2c5";

export default node;
